<template>
<div class="paySuccess-content">
  <div class="con-header"><img src="https://resource.rcclchina.com.cn/paySuccess/success.png" alt="">感谢您预订岸上观光！</div>
  <div class="con-notice">
    <div class="con-notice-left">
      您可以继续选择 <span>皇家行前订</span><br>
      <span>提前规划</span>您的海上假期，<br>
      吃喝玩乐购全覆盖，<span>行前预订价更优！</span>
    </div>
    <div class="con-notice-right">
      <img src="https://resource.rcclchina.com.cn/paySuccess/routeLogo.png" alt="">
    </div>
  </div>
  <div class="con-notice route-reserve" style="margin-top: 13px">
    <div v-for="(item,index) in skipList" :key="index" :class="item.className">
      <div class="notice-item" @click="goPcpItem(item.routeUrl)">
        <img :src="item.imgUrl" alt="">
        <div class="item-reserve">点击预定></div>
      </div>
    </div>
  </div>
  <div class="reserve-btn" @click="goPcp">前往预定</div>
  <div class="pcp-advantage">
    <img src="https://resource.rcclchina.com.cn/paySuccess/pcp-advantage.png" alt="">
  </div>
</div>
</template>
<script>
import api from "@/api";

export default {
  data(){
    return{
      skipList:[
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/wifi.png',routeUrl:'/Rccl.PCP/product/Wifi',className:''},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/catering.png',routeUrl:'/Rccl.PCP/product/dining',className:'item-food'},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/activity.png',routeUrl:'/Rccl.PCP/product/entertainment',className:''},
        {imgUrl:'https://resource.rcclchina.com.cn/paySuccess/serve.png',routeUrl:'/Rccl.PCP/product/service',className:'item-serve'}
      ],
      token:''
    }
  },
  beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "预定成功");
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: true,
    });
    this.getToken()
  },
  methods:{
    async getToken() {
      const {data} = await api.user.getPcpToken()
      if (data && data.length > 0) {
        this.token = data
      }
    },
    goPcpItem(url){
      location.href=process.env.VUE_APP_PCP_URL + url+`?token=${this.token}`
    },
    goPcp() {
      location.href = process.env.VUE_APP_PCP_URL + `/Rccl.Pcp/Home/Index?token=${this.token}`
    }
  }
}
</script>
<style lang="less" scoped>
.paySuccess-content{
  width: 100%;
  background: linear-gradient( 180deg, #0297EA 0%, #95D2F7 34%, #F6FAFF 100%);
  padding: 0 11px 27px;
  & .con-header{
    padding-top: 25px;
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 17px;
    display: flex;
    align-items: center;
    padding-left: 11px;
    gap: 8px;
    & img{
      width: 20px;
      height: 20px;
    }
  }
  & .con-notice{
    width: 100%;
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    padding: 11px 10px 10px 14px;
    & .con-notice-left{
      width: 100%;
      height: 66px;
      & span{
        color: #1B82CB;
        font-weight: 600;
      }
    }
    & .con-notice-right{
      width: 88px;
      padding: 18px 0;
      & img{
        width: 100%;
        height: 24px;
      }
    }
  }
  .route-reserve{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 7px !important;
    right: 0;
    position: relative;
    row-gap: 8px;
    & .item-food{
      position: absolute;
      top: 7px;
      right: 7px;
    }
    & .item-serve{
      position: absolute;
      bottom: 7px;
      right: 7px;
    }
    & .notice-item{
      width: 177px;
      height: 154px;
      border-radius: 5px;
      position: relative;

      & img{
        width: 100%;
        height: 100%;
      }
      & .item-reserve{
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        position: absolute;
        bottom: 5px;
        right: 7px;
      }
    }
  }
  & .reserve-btn{
    width: 100%;
    height: 46px;
    background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
    border-radius: 22px;
    margin: 25px 0 21px;
    font-weight: 500;
    font-size: 16px;
    color: #404040;
    text-align: center;
    line-height: 46px;
  }
  & .pcp-advantage{
    width: 100% ;
    height: 135px;
    border-radius: 5px;
    overflow: hidden;
    & img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>